import { Component } from 'react';
import { Alert, ListItem, ListItemText, Button, Box } from '@mui/material';

/**
 * @component SidebarErrorBoundary
 * Error boundary for cantabs sidebar menu items.
 * Catches render errors in child components and displays a compact
 * fallback UI so one broken menu item doesn't crash the entire sidebar.
 */
class SidebarErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		console.error(
			`[CANtabs/${this.props.sectionName || 'Sidebar'}] Error caught:`,
			error,
			errorInfo.componentStack,
		);
	}

	handleReset = () => {
		this.setState({ hasError: false, error: null });
	};

	render() {
		if (this.state.hasError) {
			return (
				<ListItem sx={{ flexDirection: 'column', alignItems: 'stretch', py: 1, px: 2 }}>
					<Alert severity="error" variant="outlined" sx={{ py: 0.5 }}>
						<ListItemText
							primary={`Could not load ${this.props.sectionName || 'this section'}`}
							primaryTypographyProps={{ variant: 'body2' }}
						/>
						<Box sx={{ mt: 0.5 }}>
							<Button size="small" onClick={this.handleReset}>
								Try Again
							</Button>
						</Box>
					</Alert>
				</ListItem>
			);
		}

		return this.props.children;
	}
}

export default SidebarErrorBoundary;
